import React from 'react';
import { B } from '../context/ThemeContext';
import { Card, SectionTitle, Btn, Pill } from '../components/common/UIComponents';
import { useAuth } from '../context/AuthContext';
import { AccessDenied } from '../components/common/PermissionGate';

export default function Settings() {
  const { hasPermission } = useAuth();
  
  const canManageSettings = hasPermission('manageSettings');

  if (!canManageSettings) {
    return <AccessDenied message="You don't have permission to access settings. This page is restricted to administrators only." />;
  }

  return (
    <div>
      <div style={{ fontSize: 'clamp(18px, 5vw, 24px)', fontWeight: 800, color: B.navy, marginBottom: 4 }}>Settings</div>
      <div style={{ fontSize: 12, color: B.muted, marginBottom: 20 }}>Facility configuration, integrations & preferences</div>

      <div className="responsive-grid" style={{ gap: 16 }}>
        <Card>
          <SectionTitle>Facility Information</SectionTitle>
          {[
            { label: 'Facility Name', value: 'Forward Care Hub' },
            { label: 'License Number', value: 'AFH-2022-WI-0041' },
            { label: 'Capacity', value: '6 beds' },
            { label: 'Address', value: '1420 Maple Street, Madison, WI 53703' },
            { label: 'Phone', value: '(608) 555-0142' },
            { label: 'DHS Region', value: 'Southern Region' }
          ].map((f, i) => (
            <div key={i} style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 11, fontWeight: 600, color: B.text }}>{f.label}</label>
              <div style={{ fontSize: 12, color: B.text, marginTop: 2 }}>{f.value}</div>
            </div>
          ))}
          <Btn outline color={B.navy}>Edit Facility Info</Btn>
        </Card>

        <Card>
          <SectionTitle>Notification Preferences</SectionTitle>
          {[
            ['Medication Due Reminders', true],
            ['Incident Alerts', true],
            ['Staff Clock-In/Out', false],
            ['Certification Expiry Alerts', true]
          ].map(([label, on], i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: i < 3 ? `1px solid ${B.border}` : 'none' }}>
              <span style={{ fontSize: 12, color: B.text }}>{label}</span>
              <div style={{ width: 36, height: 20, borderRadius: 20, background: on ? B.green : B.border, position: 'relative', cursor: 'pointer' }}>
                <div style={{ position: 'absolute', top: 2, left: on ? 18 : 2, width: 16, height: 16, borderRadius: '50%', background: '#fff', transition: 'left 0.2s' }} />
              </div>
            </div>
          ))}
        </Card>

        <Card>
          <SectionTitle>Integrations</SectionTitle>
          {[
            { name: 'Pharmacy Connect', status: 'Connected', color: B.green },
            { name: 'DHS Portal', status: 'Connected', color: B.green },
            { name: 'EVV System', status: 'Connected', color: B.green },
            { name: 'EHR Integration', status: 'Not Connected', color: B.muted }
          ].map((int, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: i < 3 ? `1px solid ${B.border}` : 'none' }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: B.navy }}>{int.name}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Pill c={int.color}>{int.status}</Pill>
                <Btn small outline color={B.blue}>{int.status === 'Connected' ? 'Manage' : 'Connect'}</Btn>
              </div>
            </div>
          ))}
        </Card>

        <Card>
          <SectionTitle>Security & Compliance</SectionTitle>
          {[
            { label: 'Audit Logging', value: 'Enabled', color: B.green },
            { label: 'Data Retention', value: '7 years', color: B.teal },
            { label: 'Backup Status', value: 'Last night 2:00 AM', color: B.green },
            { label: 'HIPAA Compliance', value: 'Certified', color: B.green },
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: i < 3 ? `1px solid ${B.border}` : 'none' }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: B.navy }}>{item.label}</span>
              <Pill c={item.color}>{item.value}</Pill>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}